import _ from "lodash";

export function filterCaseInsensitiveReactTable(filter, row) {
    const id = filter.pivotId || filter.id;
    const rowElement = row[id];
    const filterValue = filter?.value;
    return (
        _.isEmpty(rowElement) ? false : String(rowElement.toLowerCase()).includes(filterValue?.toLowerCase())
    );
}